/*
 * <sale-clock>: DD : HRS : MINS : SECS countdown for the announcement bar offer.
 * If the homepage sale banner has its own countdown on the page, this clock uses that exact end
 * time so both timers always read the same.
 */
if (!customElements.get('sale-clock')) {
  class SaleClock extends HTMLElement {
    connectedCallback() {
      const banner = document.querySelector('[id$="__image_banner_wrzakT"] custom-countdown[data-end-date]');
      const source = (banner && banner.dataset.endDate) || this.dataset.end;
      this.end = new Date(source).getTime();
      if (!Number(this.end)) return;

      this.parts = {};
      this.querySelectorAll('[data-part]').forEach((el) => { this.parts[el.dataset.part] = el; });
      this.tick();
      // Align ticks to the wall-clock second so both timers flip together
      setTimeout(() => {
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }, 1000 - (Date.now() % 1000));
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = Math.max(0, this.end - Date.now());
      const total = Math.floor(remaining / 1000);
      const values = {
        d: Math.floor(total / 86400),
        h: Math.floor((total % 86400) / 3600),
        m: Math.floor((total % 3600) / 60),
        s: total % 60,
      };
      for (const key in values) {
        const text = String(values[key]).padStart(2, '0');
        if (this.parts[key] && this.parts[key].textContent !== text) this.parts[key].textContent = text;
      }
      if (remaining === 0) {
        clearInterval(this.timer);
        this.closest('.offer-bar')?.classList.add('offer-bar--ended');
      }
    }
  }

  customElements.define('sale-clock', SaleClock);
}
